import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const draggerDefaultVariants = {
  "size": "md",
  "state": "idle"
}
const draggerCompoundVariants = []

const draggerSlotNames = [
  [
    "root",
    "dragger__root"
  ],
  [
    "container",
    "dragger__container"
  ],
  [
    "icon",
    "dragger__icon"
  ],
  [
    "text",
    "dragger__text"
  ],
  [
    "uploadButton",
    "dragger__uploadButton"
  ],
  [
    "buttonText",
    "dragger__buttonText"
  ],
  [
    "buttonIcon",
    "dragger__buttonIcon"
  ]
]
const draggerSlotFns = /* @__PURE__ */ draggerSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, draggerDefaultVariants, getSlotCompoundVariant(draggerCompoundVariants, slotName))])

const draggerFn = memo((props = {}) => {
  return Object.fromEntries(draggerSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const draggerVariantKeys = [
  "size",
  "state"
]
const getVariantProps = (variants) => ({ ...draggerDefaultVariants, ...compact(variants) })

export const dragger = /* @__PURE__ */ Object.assign(draggerFn, {
  __recipe__: false,
  __name__: 'dragger',
  raw: (props) => props,
  variantKeys: draggerVariantKeys,
  variantMap: {
  "size": [
    "sm",
    "md",
    "lg"
  ],
  "state": [
    "idle",
    "dragging",
    "loading"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, draggerVariantKeys)
  },
  getVariantProps
})